import * as React from 'react';
import styled from 'styled-components';
import { Link } from './Link';

export type FooterLinkProps = {
  actionId: string;
  to: string;
  target?: string;
  className?: string;
};

const StyledLink = styled(Link)`
  font-size: 0.7rem;
  padding: 0;
  color: rgba(69, 69, 69, 0.3);

  :active {
    color: rgba(69, 69, 69, 0.6);
    background-color: transparent;
  }
`;

export const FooterLink: React.SFC<FooterLinkProps> = ({ children, to, actionId, target, className }) => (
  <StyledLink to={to} actionId={actionId} target={target} className={className}>
    {children}
  </StyledLink>
);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/links/FooterLink.tsx